/**
 * Dashboard route.
 *
 * Gated on a referral code being present in localStorage: without one the
 * purchase flow cannot build a valid transaction, so the terminal login is shown
 * instead of a dashboard that would fail at the last step.
 */
import { useEffect } from "react";

import { Dashboard } from "@/components/Dashboard/Dashboard";
import { TerminalLogin } from "@/components/TerminalLogin/TerminalLogin";
import { useSuiQueryContext } from "@/context/SUIQuery/useSuiQueryContext";
import { REFERRAL_CODE_STORAGE_KEY } from "@/lib/referral";

export default function DashboardPage() {
  const { isReferralCodeSet, setIsReferralCodeSet } = useSuiQueryContext();

  useEffect(() => {
    const lsReferralCode = localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);

    setIsReferralCodeSet(lsReferralCode !== null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only read; the setter is stable
  }, []);

  if (!isReferralCodeSet) {
    return <TerminalLogin isReferralCodeSet={isReferralCodeSet} />;
  }

  return <Dashboard />;
}
